var map = {
	"./accepted.svg": [
		7454,
		454
	],
	"./checkmark.svg": [
		4260,
		260
	],
	"./declined.svg": [
		8603,
		603
	],
	"./global.svg": [
		7892,
		892
	],
	"./logo-main.svg": [
		658,
		658
	],
	"./logo.svg": [
		9328,
		328
	],
	"./noResponse.svg": [
		6721,
		721
	],
	"./sparkles.svg": [
		7764
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4259;
module.exports = webpackAsyncContext;